import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalDarkModeController {

  private localId: string;
  private darkModeSubject: BehaviorSubject<boolean>;
  darkModeChanged$: Observable<boolean>;

  constructor(localId: string) {
    this.localId = localId;
    const isDarkModeEnabled = this.getStoredConfiguration();
    this.darkModeSubject = new BehaviorSubject<boolean>(isDarkModeEnabled);
    this.darkModeChanged$ = this.darkModeSubject.asObservable();
  }

  // Toggle Dark Mode
  toggleDarkMode(): void {
    const isDarkModeEnabled = !this.darkModeSubject.value;
    localStorage.setItem(this.localId + '.isDarkModeEnabled', JSON.stringify(isDarkModeEnabled));
    this.darkModeSubject.next(isDarkModeEnabled);
  }

  // Is Dark Mode Enabled
  isDarkModeEnabled(): boolean {
    return this.darkModeSubject.value;
  }

  // Get Stored Configuration
  private getStoredConfiguration(): boolean {
    const isDarkModeEnabled = localStorage.getItem(this.localId + '.isDarkModeEnabled');
    if (isDarkModeEnabled === null) {
      return false;
    } else {
      return JSON.parse(isDarkModeEnabled);
    }
  }
}
